import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/context/AuthContext';
import { useOrgs } from '@/context/OrgsProvider';
import { authenticatedBitswanBackendInstance } from '@/lib/api-client';

export function useOrgRoles() {
  const { isAuthenticated } = useAuth();
  const { activeOrg } = useOrgs();

  const query = useQuery<string[]>({
    queryKey: ['org-roles', activeOrg?.id],
    queryFn: async () => {
      const api = await authenticatedBitswanBackendInstance();
      const res = await api.get('/org-roles/');
      return (res.data?.roles ?? []) as string[];
    },
    enabled: isAuthenticated && !!activeOrg,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  const roles = query.data ?? [];
  return {
    roles,
    has: (role: string) => roles.includes(role),
    isAnswered: query.isFetched || query.isError || !isAuthenticated,
  };
}
